import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ConfigService, FormsUtilsService, MessageService, notCloseMessageOptions } from '../../../../../core';
import { ConfigPedido, ConfigPedidoTipoVendaIndicador, ConfigPedidoUtilsService, isAmostra, isBonificacao, isConsignacao, isVenda, isSimulacao, isOrcamento, ConfigPedidoTipoVendaSinonimoPipe, isConfigPedidoModoPagamentoManual, isConfigPedidoModoPagamentoCondicaoPagamento } from '../../../../configuracoes/app/pedido';
import { ICondicaoPagamento } from '../../../../../domains/environment/condicoes-pagamentos/interfaces/condicao-pagamento.interface';
import { EnumSituacaoCondicaoPagamento } from '../../../../../domains/environment/condicoes-pagamentos/enums/situacao-condicao-pagamento.enum';
import { ITokenFieldSettings, ITokenItem } from '../../../../../domains/shared/components/tokenfield/tokenfield.component';
import { generateLocalId } from '../../../../../domains/aya/utils/local-id.util';
import { FormaPagamentoSelectComponent } from '../../../../forma-pagamento/select/forma-pagamento-select.component';
import { ConfigCliente } from '../../../../configuracoes/app/cliente';
import { ClienteAuthGuardService } from '../../services';
import { ClienteModoEnvioBoletoSelectComponent, isModoEnvioBoletoEmail } from '../boleto';
import { ClienteFinanceiro } from '../cliente-financeiro';
interface Config {
    isModoEnvioBoletoRequired: boolean;
    isShowEmailBoleto: boolean;
    isPagamentoViaPIXRequired: boolean;
    canEditTipoPagamento: boolean;
    isModoPagamentoManual: boolean;
    isModoPagamentoCondicaoPagamento: boolean;
}

@Component({
    selector: 'sgt-cliente-financeiro-form',
    templateUrl: './cliente-financeiro-form.component.html',
    styleUrls: ['./cliente-financeiro-form.component.less']
})
export class ClienteFinanceiroFormComponent implements OnInit, OnChanges {
    config: Config;
    configCliente: ConfigCliente;
    configPedido: ConfigPedido;

    readonly situacoesCondicaoPagamento = [
        EnumSituacaoCondicaoPagamento.ATIVA,
        EnumSituacaoCondicaoPagamento.CLIENTE,
    ];

    /** Se pode editar os dados do form */
    @Input() canEdit = true;
    /** Se está editando */
    @Input() editMode: boolean;
    @Input() entity: ClienteFinanceiro;

    @ViewChild('form') form: NgForm;
    @ViewChild('modoEnvioBoletoSelect') modoEnvioBoletoSelect: ClienteModoEnvioBoletoSelectComponent;
    @ViewChild('emailBoletoInput') emailBoletoInput: ElementRef;
    @ViewChild('emailPIXInput') emailPIXInput: ElementRef;

    // Condição de Pagamento
    @ViewChild('formaPagamentoSelect') formaPagamentoSelect: FormaPagamentoSelectComponent;

    prazosMediosTokens: ITokenItem[] = [];

    readonly prazosMediosSettings: ITokenFieldSettings = {
        placeholder: 'Ex.: 30, 60, 90',
        minLength: 1,
    };

    constructor(private configService: ConfigService,
                private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private clienteAuthGuardService: ClienteAuthGuardService) { }

    ngOnInit() {
        this.configCliente = this.configService.getCliente();
        this.configPedido = this.configService.getPedido();
        this.setConfig();
        this.carregarTokensPrazosMedios();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.entity && !changes.entity.firstChange) {
            this.carregarTokensPrazosMedios();
        }
    }

    private carregarTokensPrazosMedios() {
        this.prazosMediosTokens = (this.entity?.prazosMediosPagamento ?? []).map(
            (n) => ({ id: generateLocalId(), label: String(n) })
        );
    }

    onPrazosMediosChange(tokens: ITokenItem[]) {
        this.prazosMediosTokens = tokens;
        const prazos = Array.from(
            new Set(
                tokens
                    .map((t) => Number(t.label))
                    .filter((n) => Number.isInteger(n) && n > 0)
            )
        );
        this.entity.prazosMediosPagamento = prazos.length ? prazos : null;
    }

    private setConfig() {
        this.config = {
            isModoEnvioBoletoRequired: this.configCliente.obrigarModoEnvioBoleto,
            isShowEmailBoleto: isModoEnvioBoletoEmail(this.entity.modoEnvioBoleto),
            isPagamentoViaPIXRequired: this.configCliente.obrigarPagamentoViaPIX,
            canEditTipoPagamento: this.clienteAuthGuardService.canEditTipoPagamento(this.editMode, this.entity),
            isModoPagamentoManual: isConfigPedidoModoPagamentoManual(this.configPedido.modoPagamento),
            isModoPagamentoCondicaoPagamento: isConfigPedidoModoPagamentoCondicaoPagamento(this.configPedido.modoPagamento)
        }
    }

    /** Seta o foco no input do e-mail de boleto */
    private setFocusEmailBoletoInput() {
        jQuery(this.emailBoletoInput.nativeElement).trigger('focus')
    }

    /** Ao alterar o modo de envio dos boletos */
    onChangeModoEnvioBoleto(modoEnvioBoleto: number) {
        this.entity.modoEnvioBoleto = modoEnvioBoleto;
        this.config.isShowEmailBoleto = isModoEnvioBoletoEmail(this.entity.modoEnvioBoleto);

        if (this.config.isShowEmailBoleto) {
            setTimeout(() => this.setFocusEmailBoletoInput(), 200);
        }
    }

    /** Seta o foco no input do e-mail de PIX */
    private setFocusEmailPIXInput() {
        jQuery(this.emailPIXInput.nativeElement).trigger('focus')
    }

    /** Ao alterar a flag de enviar PIX por e-mail */
    onChangeEnviarPIXPorEmail(enviarPIXporEmail: boolean) {
        this.entity.enviarPIXPorEmail = enviarPIXporEmail;
        if (this.entity.enviarPIXPorEmail) {
            setTimeout(() => this.setFocusEmailPIXInput(), 0);
        }
    }

    /** Ao alterar a condição de pagamento */
    onChangeCondicaoPagamento(condicaoPagamento: ICondicaoPagamento | null) {
        this.entity.condicaoPagamento = condicaoPagamento as unknown as ClienteFinanceiro['condicaoPagamento'];
        // Setando a forma de pagamento da condição de pagamento selecionada
        this.formaPagamentoSelect?.onChange(condicaoPagamento?.idFormaPagamento ?? null);
    }

    /** Seta os dados financeiro ao inserir um novo cliente */
    insert() {
        // Setando modo de envio dos boletos padrão
        this.onChangeModoEnvioBoleto(this.configCliente.modoEnvioBoleto);
        // Setando as flags de pagamento via PIX
        this.entity.pagamentoViaPIX = this.configCliente.pagamentoViaPIX;
        this.entity.enviarPIXPorEmail = this.configCliente.enviarPIXPorEmail;
    }


    /** Verifica se o formulário está válido */
    isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        /** Boletos */
        // Modo envio do boleto
        if (this.config.isModoEnvioBoletoRequired && !this.entity.modoEnvioBoleto) {
            this.messageService.warning('Selecione como o cliente deseja receber os boletos', 'Modo de envio dos boletos não informado', notCloseMessageOptions);
            this.modoEnvioBoletoSelect.setFocus();
            return false;
        }

        // E-mail de boleto
        if (this.config.isShowEmailBoleto && (!this.entity.emailBoleto || this.entity.emailBoleto.trim() == '')) {
            this.messageService.warning('Informe o e-mail que o cliente deseja receber os boletos', 'E-mail de boleto não informado', notCloseMessageOptions);
            this.setFocusEmailBoletoInput();
            return false;
        }

        /** PIX */
        // Pagamento Via PIX
        if (this.config.isPagamentoViaPIXRequired && (this.entity.pagamentoViaPIX == null || this.entity.pagamentoViaPIX === undefined)) {
            this.messageService.warning('Selecione se o cliente deseja pagar via PIX', 'Pagamento via PIX não informado', notCloseMessageOptions);
            return false;
        }

        // Enviar PIX por e-mail
        if (this.entity.pagamentoViaPIX && (this.entity.enviarPIXPorEmail == null || this.entity.enviarPIXPorEmail === undefined)) {
            this.messageService.warning('Selecione se o cliente deseja receber os links de pagamentos via PIX por e-mail', 'Opção de cliente receber links de pagamentos via PIX não informada', notCloseMessageOptions);
            return false;
        }

        // E-mail PIX
        if (this.entity.enviarPIXPorEmail && (!this.entity.emailPIX || this.entity.emailPIX.trim() == '')) {
            this.messageService.warning('Informe o e-mail que o cliente deseja receber os links de pagamentos via PIX', 'E-mail de PIX não informado', notCloseMessageOptions);
            this.setFocusEmailPIXInput();
            return false;
        }

        // Form inválido
        if (this.form.invalid) {
            this.messageService.warning('Para salvar é preciso informar corretamente todos os campos destacados em vermelho nos dados financeiros', 'Atenção');
            return false;
        }

        return true;
    }

    resolve() {
        /** Boletos */
        // Removendo e-mail de boleto
        if (!isModoEnvioBoletoEmail(this.entity.modoEnvioBoleto)) {
            this.entity.emailBoleto = null;
        }

        /** PIX **/
        // Removendo envio do PIX
        if (!this.entity.pagamentoViaPIX) {
            this.entity.enviarPIXPorEmail = null;
        }
        // Removendo e-mail de PIX
        if (!this.entity.enviarPIXPorEmail) {
            this.entity.emailPIX = null;
        }
    }
}
